import request from '@/utils/request'

export function getHolidayTypes (data) {
  return request({
    url: '/api/admin/holiday-types',
    method: 'post',
    data: data
  })
}